module.exports = __webpack_public_path__ + "img/greychevoron.61337f27.svg";